export default class CarouselModel {
    constructor({ count, goToStepCallback, startIndex = 1 }) {
        this.count = count;
        this.index = startIndex;
        this.goToStepCallback = goToStepCallback;
        this.interval = null;
        this.delayCounter = 1;
    }

    start() {
        this.goToStep(this.index);
        this.interval = window.setInterval(() => {
            const shouldAttemptTransition = this.delayCounter % 5 === 0;
            const canTransition = document.readyState === 'complete';
            if (shouldAttemptTransition) {
                if (canTransition) {
                    this.next();
                    this.delayCounter = 1;
                }
            } else {
                this.delayCounter += 1;
            }
        }, 1000);
    }

    stop() {
        window.clearInterval(this.interval);
    }

    next() {
        this.goToStep(this.index + 1);
    }

    goToStep(stepIndex) {
        this.index = Math.abs(stepIndex) % this.count || this.count;

        this.goToStepCallback(this.index);
    }
}



// WEBPACK FOOTER //
// ./src/web/js/contest/models/carousel-model.js